import React, { useState, useEffect, useCallback } from "react";
import AddIcon from "../../../assets/AddBankIcon.svg";
import backicon from "../../../../../Assets/backicon.svg";
import chip from "../../../../../Assets/Chip.svg";
import indicator from "../../../../../Assets/Indicator.svg";
import mastercard from "../../../../../Assets/mastercard.svg";
import deleteIcon from "../../../assets/delete-icon.svg";

import "../Card/CardModal/CardIndex";
import "../BankCards/BankCard.css";
import CardIndex from "./CardModal/CardIndex";
import { FWPUBK } from "../../../../../../helpers/config";
import { useUser } from "../../../../../../hooks/use-user";
import { $api } from "../../../../../../helpers/$api";
import { toast } from "react-toastify";
import { Util } from "../../../../../../helpers/util";

const BankCards = () => {
  const user = useUser();
  const [section, setSection] = useState(0);
  const [userCards, setUserCards] = useState([]);

  const getCards = useCallback(async () => {
    try {
      const userCards = await $api.user.getUserCards();

      setUserCards(userCards);
    } catch (error) {
      // error getting cards
    }
  }, [setUserCards]);

  useEffect(() => {
    getCards();
  }, [getCards]);

  const handleCardAdd = () => {
    // eslint-disable-next-line no-undef
    FlutterwaveCheckout({
      public_key: FWPUBK,
      tx_ref: `tx_ref-${Util.generateRandomString(5)}`,
      amount: 50,
      ...Util.getFlutterCurrencyAndCountryFromUserCountry(user.country),
      payment_options: "card",
      customer: {
        email: user.email,
        phone_number: user.phone,
        name: `${user.firstname} ${user.lastname}`,
      },
      callback: async function (data) {
        try {
          await $api.user.verifyCardTransaction(data.transaction_id);
          getCards();
          toast.success("card added successfully");
        } catch (error) {
          toast.error(`error adding card - ${error.message}`);
        }
      },
      customizations: {
        title: "OVest",
        description: "Add new card",
        logo: "https://myovest.com//img/logo.png",
      },
    });
  };

  const handleDelete = async (card) => {
    const prv = userCards;
    try {
      // eslint-disable-next-line no-restricted-globals
      if (confirm("are you sure you want to delete this card")) {
        const w = userCards.filter((cd) => cd.id !== card.id);
        setUserCards(w);

        await $api.user.deleteCard(card.id);
        toast.success("card deleted successfully");
      }
    } catch (error) {
      toast.error(`error deleting card - ${error.message}`);
      setUserCards(prv);
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
        }}
      >
        <div className="bank-details" onClick={handleCardAdd}>
          <img src={AddIcon} alt="add-icon" className="bank-icon" />
          <p className="bank-text">Add cards</p>
        </div>

        {userCards.map((card) => {
          return (
            <div className="atm-card bank-items" key={card.id}>
              <div className="delete-screen">
                <p className="delete-button" onClick={() => handleDelete(card)}>
                  <img
                    src={deleteIcon}
                    alt="delete-icon"
                    className="delete-icon"
                  />
                  <span
                    style={{
                      color: "#dd0707",
                    }}
                  >
                    Delete Card
                  </span>
                </p>
              </div>
              <div className="atm-card-content">
                <div className="atm-card-title">
                  <img src={chip} alt="atm-chip" />
                  <img src={indicator} alt="atm-chip" />
                </div>
                <div class="atm-card-body">
                  <p>{card.card}</p>
                  <div className="valid-date">
                    <p>
                      VALID <br /> TILL
                    </p>
                    <p>01/22</p>
                  </div>
                </div>

                <div className="atm-card-footer">
                  <p>
                    Card Holder : {card.firstname} {card.lastname}{" "}
                  </p>
                  <img src={mastercard} alt="card-type-img" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <>
        <div id="CardModal" className="bankcard-modal">
          <div className="accountmodal-head">
            {section === 0 ? (
              <a href="#dummy" className="backicon">
                <img src={backicon} alt="back icon" className="back-icon" />
              </a>
            ) : null}
            <CardIndex {...{ section, setSection }} />
          </div>
        </div>
      </>
    </div>
  );
};

export default BankCards;
